import { z } from "zod";

/**
 * The shelf scanned at the rack, which is what closes a put-away.
 *
 * A **code** rather than a `warehouseLocationId`, because a shelf label carries its name —
 * `R05-F007-E001`, the shelf, axis and floor the row is keyed on — and that is what a scanner
 * emits. Resolving it is the server's job for the same reason the trolley scan is: the picking
 * screen matches the same two forms against a list it already holds, and this one has no such
 * list, so a client asked to resolve it would need a lookup endpoint of its own and would then be
 * the second place the matching rule lives.
 *
 * The scan is required, and that is the point of the whole step: the leg names a destination
 * chosen at the gate, and only somebody standing at a rack can say where the material actually
 * went. A scan naming a different shelf the article is assigned to re-targets the leg; a scan
 * naming any other shelf is refused.
 */
export const patchPutAwayCompleteJsonSchema = z.object({
	warehouseLocationCode: z.string().min(1),
});

export type PatchPutAwayCompleteJsonSchema = z.infer<typeof patchPutAwayCompleteJsonSchema>;
